<div id="PG_PaymentManagement" class="glb_formBGColor glb_paddingBottomMD glb_Font glb_Font" [ngClass]="ModalIdentifier">

    <!-- Close modal button. put this here on its own row, so that it stays put and won't bootstrap down to another row in smaller screen sizes -->
    <div class="glb_customFlexRow sticky-top">
        <div class="glb_headerBarBGDark glb_customFlexRow col-12 justify-content-end" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
            <div class="justify-content-start glb_boxedPaddingNarrow align-self-bottom glb_PaddingVerticalZeroOffset">
                <button id="BTN_ClosePaymentManagement" tabindex="3"
                    class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                    (click)="globalFunctions.FeatureModal_Close(ModalIdentifier)">
                    <fa-icon [icon]="['fal', 'times']" class="fa-md glb_iconColorDark" matTooltip="Click to close"></fa-icon>
                </button>
            </div>
        </div>
    </div>
    <div class="glb_customFlexRow glb_boxedPadding">
        <div class="col-12 glb_Font header-padding glb_customFlexRow">
            <div class="glb_customFlexRow col-12">
                <div class="glb_customFlexRow col-12 col-md-8 col-lg-8 glb_paddingZeroOffset glb_paddingBottomSM">
                    <div class="col-12 glb_paddingZeroOffset">
                        <div class="glb_TitleLG glb_TitleLGMobile text-start glb_breakLongWords glb_paddingZeroOffset glb_paddingBottomSM text-white">
                            Payment Management
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="glb_customFlexRow col-12">

            <!-- Left side navigation column (vertical tabs) -->
            <div class="col-3 glb_minModalHeight">

                <!-- Nav Tabs for Payment management -->
                <div id="LBL_PaymentNavBarID" class="glb_Font col-12">
                    <div class="nav nav-tabs flex-column">
                        <button [ngClass]="{'active': IsActiveTab_Check('manageDirectDebit')}"
                            class="glb_customFlexRow align-self-stretch navItemBorder nav-item nav-link" (click)="CurrentTab = 'manageDirectDebit'"
                            id="BTN_ManageDirectDebit">
                            <div class="glb_customFlexRow justify-content-start align-self-center col-12">
                                <div class="glb_TitleSmall glb_TitleSmallMobile">
                                    Direct Debit
                                </div>
                            </div>
                        </button>
                        <button *ngIf="ViewProcessInterAccountTransfer" [ngClass]="{'active': IsActiveTab_Check('interAccountTransfer')}"
                            class="glb_customFlexRow align-self-stretch navItemBorder nav-item nav-link" (click)="CurrentTab = 'interAccountTransfer'"
                            id="BTN_InterAccountTransfer">
                            <div class="glb_customFlexRow justify-content-start align-self-center col-12">
                                <div class="glb_TitleSmall glb_TitleSmallMobile">
                                    Inter Account Transfer
                                </div>
                            </div>
                        </button>
                        <button [ngClass]="{'active': IsActiveTab_Check('salaryCredit')}"
                            class="glb_customFlexRow align-self-stretch navItemBorder nav-item nav-link" (click)="CurrentTab = 'salaryCredit'"
                            id="BTN_SalaryCredit">
                            <div class="glb_customFlexRow justify-content-start align-self-center col-12">
                                <div class="glb_TitleSmall glb_TitleSmallMobile">
                                    Direct Credit / Salary Credit / BPAY
                                </div>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Right side content area -->
            <div class="col-9">

                <!-- Manage a Direct Debit tab content -->
                <div *ngIf="CurrentTab === 'manageDirectDebit' || !CurrentTab" class="glb_boxedPadding glb_formBGColor text-white glb_Font col-12">
                    <div class="text-white glb_customFlexRow row-cols-1 justify-content-left col-12">

                        <!-- Content for Manage a Direct Debit tab -->
                        <div class="glb_customFlexRow col-12">
                            <div class="col-12">
                                <!-- Single container with white border for all content -->
                                <div class="glb_allBordersGreyRounded glb_boxedPadding">
                                    <!-- Bank Account Details Section -->
                                    <div class="glb_TitleMD glb_paddingBottomSM">Bank Account Details</div>
                                    <div class="glb_customFlexRow">
                                        <div class="glb_customFlexRow glb_paddingBottomXS" *ngIf="BankAccountDetails">
                                            <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="BankAccountDetails">
                                                <div class="col-3 glb_LabelFontDark">BSB Number:</div>
                                                <div class="col-9 text-white">{{BankAccountDetails.AccountBSBNo || 'Not provided'}}</div>
                                            </div>
                                            <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="BankAccountDetails">
                                                <div class="col-3 glb_LabelFontDark">Account Number:</div>
                                                <div class="col-9 text-white">{{BankAccountDetails.AccountNumber || 'Not provided'}}</div>
                                            </div>
                                            <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="BankAccountDetails">
                                                <div class="col-3 glb_LabelFontDark">Account Name:</div>
                                                <div class="col-9 text-white">{{BankAccountDetails.AccountName || 'Not provided'}}</div>
                                            </div>
                                            <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="BankAccountDetails">
                                                <div class="col-3 glb_LabelFontDark">Bank Name:</div>
                                                <div class="col-9 text-white">{{BankAccountDetails.BankName || 'Not provided'}}</div>
                                            </div>
                                        </div>
                                        <div class="glb_customFlexRow glb_paddingBottomXS" *ngIf="!BankAccountDetails">
                                            <div class="col-12 glb_whiteTextDarkBG">No bank account details available.</div>
                                        </div>
                                    </div>

                                    <div class="glb_customFlexRow col-12 glb_paddingTopXS">
                                        <!-- Buttons row for Add and Edit -->
                                        <div class="glb_customFlexRow glb_paddingTopXS" *ngIf="BankAccountDetails">
                                            <div class="col-12 glb_customFlexRow justify-content-start">
                                                <div *ngIf="!IsPaymentBeingEdited" class="glb_paddingRightXS">
                                                    <button id="BTN_AddBankAccount"
                                                        class="glb_standardButton btn glb_BGColorSkin glb_whiteTextDarkBG col-12"
                                                        (click)="PaymentManagementModify_Launch('EditBankAccount')">
                                                        <span class="glb_Font glb_smallerText">Edit</span>
                                                    </button>
                                                </div>
                                                <div *ngIf="IsPaymentBeingEdited" class="glb_paddingRightXS">
                                                    <button
                                                        class="glb_standardButton btn glb_BGColorSkin glb_whiteTextDarkBG glb_clickableIconButtonColorDisabled col-12">
                                                        <span class="glb_Font glb_smallerText">Edit</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Show this if no bank account details are available -->
                                        <div class="glb_customFlexRow glb_paddingBottomXS" *ngIf="!BankAccountDetails">
                                            <!-- Show only Add button when no bank account details exist -->
                                            <div *ngIf="!IsPaymentBeingEdited" class="glb_paddingRightXS">
                                                <button id="BTN_AddNewBankAccount"
                                                    class="glb_standardButton btn glb_BGColorSkin glb_whiteTextDarkBG col-12"
                                                    (click)="PaymentManagementModify_Launch('EditBankAccount')">
                                                    <span class="glb_Font glb_smallerText">Add</span>
                                                </button>
                                            </div>
                                            <div *ngIf="IsPaymentBeingEdited" class="glb_paddingRightXS">
                                                <button
                                                    class="glb_standardButton btn glb_BGColorSkin glb_whiteTextDarkBG glb_clickableIconButtonColorDisabled col-12">
                                                    <span class="glb_Font glb_smallerText">Add</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div class="glb_customFlexRow glb_paddingBottomXS">
                                            <!-- Generate Letter Button -->
                                            <div *ngIf="!IsPaymentBeingEdited" class="">
                                                <button id="BTN_GenerateBankDetailsLetter" tabindex="19"
                                                    class="glb_standardButton btn glb_BGColorSkin text-white col-12"
                                                    (click)="BankDetailsLetter_Generate()" [disabled]="!EnableGenerateLetterButton"
                                                    [ngClass]="CSS_Disable()">
                                                    <span class="glb_Font glb_smallerText">Generate Letter</span>
                                                </button>
                                            </div>
                                            <div *ngIf="IsPaymentBeingEdited" class="">
                                                <button id="BTN_GenerateBankDetailsLetter" tabindex="19"
                                                    class="glb_standardButton btn glb_BGColorSkin glb_whiteTextDarkBG glb_clickableIconButtonColorDisabled col-1">
                                                    <span class="glb_Font glb_smallerText">Generate Letter</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Divider/gap between sections -->
                                    <div class="glb_emptyRowMD"></div>
                                    <hr class="glb_hrLineLightFaint">
                                    <div class="glb_emptyRowSM"></div><!-- Scheduled Payments Section with title and icon buttons -->
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomSM align-items-center">
                                        <div class="col-10">
                                            <div class="glb_TitleMD">Scheduled Payments</div>
                                        </div>
                                        <div class="col-2 d-flex justify-content-end">

                                            <!-- Icon button for setting up new Payment -->
                                            <div *ngIf="!IsPaymentBeingEdited" class="d-flex justify-content-end">
                                                <span>
                                                    <button id="BTN_SetCustomerNominated"
                                                        class="glb_clickableIconButtonStyle glb_BGColorSkin glb_whiteTextDarkBG"
                                                        matTooltip="Set up new payment" (click)="overlayPanel_NewPayment.toggle($event)"
                                                        [disabled]="IsPaymentBeingEdited">
                                                        <fa-icon [icon]="['fal', 'money-check-dollar-pen']" class="fa-md"></fa-icon>
                                                    </button>
                                                </span>
                                            </div>
                                            <div *ngIf="IsPaymentBeingEdited">
                                                <span>
                                                    <button class="glb_clickableIconButtonStyle glb_BGColorSkin glb_clickableIconButtonColorDisabled"
                                                        [disabled]="true">
                                                        <fa-icon [icon]="['fal', 'money-check-dollar-pen']" class="fa-md"></fa-icon>
                                                    </button>
                                                </span>
                                            </div>

                                            <!-- This is the overlay panel for the new payment setup-->
                                            <p-popover #overlayPanel_NewPayment id="LBL_OPNewPayment"
                                                styleClass="glb_primeng_overlayPanel_sm glb_primeng_overlayPanel_default">
                                                <div class="glb_customFlexRow">
                                                    <div class="col-12 glb_boxedPaddingXS">
                                                        <button id="BTN_LaunchScheduledPaymentSetup"
                                                            class="glb_standardButton glb_skinLightOutline glb_standardButtonTight glb_BGColorSkin text-white"
                                                            (click)="ScheduledPaymentSetup_Click()">Scheduled</button>
                                                    </div>
                                                    <div class="col-12 glb_boxedPaddingXS">
                                                        <button id="BTN_LaunchCustomerNominatedPaymentSetup"
                                                            class="glb_standardButton glb_skinLightOutline glb_standardButtonTight glb_BGColorSkin text-white"
                                                            (click)="CustomerNominatedPaymentSetup_Click()">Customer
                                                            Nominated</button>
                                                    </div>
                                                </div>
                                            </p-popover>
                                        </div>
                                    </div>

                                    <!-- Scheduled payments list header -->
                                    <div class="glb_customFlexRow col-12 row-cols-9 glb_paddingBottomXS">
                                        <div class="glb_LabelFontDark pe-2">Frequency</div>
                                        <div class="glb_LabelFontDark d-flex justify-content-end pe-2">Direct Debit Amount</div>
                                        <div class="glb_LabelFontDark d-flex justify-content-end pe-2">Instalment Amount</div>
                                        <div class="glb_LabelFontDark d-flex justify-content-end pe-2">Next Payment Due Date</div>
                                        <div class="glb_LabelFontDark d-flex justify-content-end pe-2">Expiry Date</div>
                                        <div class="glb_LabelFontDark pe-2">Payment Method</div>
                                        <div class="glb_LabelFontDark pe-2">Scheduled Fee</div>
                                        <div class="glb_LabelFontDark pe-2">Notes</div>
                                        <div class="glb_LabelFontDark d-flex justify-content-end">Actions</div>
                                    </div>

                                    <!-- Divider after header -->
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS">
                                        <div class="col-12">
                                            <div class="horizontalLine"></div>
                                        </div>
                                    </div> <!-- Scheduled payments list rows -->
                                    <div *ngFor="let payment of ScheduledPaymentDetails; let i = index"> <!-- Payment details as a clickable row -->
                                        <div class="glb_customFlexRow col-12 row-cols-9 clickable-row glb_PaddingVerticalSM"
                                            [ngClass]="PaymentCSS_Get(payment)" (click)="SelectPayment_Row(payment.GUID)">
                                            <div class="pe-2">{{payment.Frequency}}</div>
                                            <div class="d-flex justify-content-end pe-2">{{payment.DirectDebitAmount_lbl}}</div>
                                            <div class="d-flex justify-content-end pe-2">{{payment.InstalmentAmount_lbl}}</div>
                                            <div class="d-flex justify-content-end pe-2">{{payment.NextPaymentDate}}</div>
                                            <div class="d-flex justify-content-end pe-2">{{payment.ExpiryDate}}</div>
                                            <div class="pe-2">{{payment.PaymentMethod}}</div>
                                            <div class="pe-2">{{payment.ConsolidatedFeeAmount_lbl}}
                                                <button *ngIf="payment.ScheduledPaymentFeeList && payment.ScheduledPaymentFeeList.length > 0"
                                                    id="BTN_ShowFeeDetails" class="glb_clickableIconButtonMD align-self-right BGColorGreyCircular"
                                                    (click)="ShowFeeDetails_Click(ViewFeeDetailsTemplate, payment)">
                                                    <fa-icon [icon]="['fal', 'magnifying-glass']" class="fa-fw glb_fixedSizeIcons IconColorDark"
                                                        matTooltip="View fee details" matTooltipPosition="right">
                                                    </fa-icon> </button>
                                            </div>
                                            <div class="pe-2" [matTooltip]="payment.Notes.length > TextDisplayLimit ? payment.Notes : ''"
                                                matTooltipPosition="above">{{payment.Notes.length > TextDisplayLimit ? (payment.Notes |
                                                slice:0:TextDisplayLimit) + '...' : payment.Notes}}</div>
                                            <div class="d-flex justify-content-end">
                                                <div class="d-flex justify-content-end">
                                                    <!-- Edit button - shown only when not in edit mode -->
                                                    <div *ngIf="!payment.AllowEditing && !IsPaymentBeingEdited">
                                                        <span>
                                                            <button
                                                                class="glb_clickableIconButtonStyle glb_clickableIconButtonColorLight btn-secondary"
                                                                (click)="Payment_Modify(payment)" matTooltip="Click to edit this payment"
                                                                id="BTN_Edit">
                                                                <fa-icon [icon]="['fal', 'edit']" class="fa-md"></fa-icon>
                                                            </button>
                                                        </span>
                                                    </div>
                                                    <div *ngIf="!payment.AllowEditing && IsPaymentBeingEdited">
                                                        <span>
                                                            <button
                                                                class="glb_clickableIconButtonStyle glb_BGColorSkin glb_clickableIconButtonColorDisabled"
                                                                [disabled]="true">
                                                                <fa-icon [icon]="['fal', 'edit']" class="fa-md"></fa-icon>
                                                            </button>
                                                        </span>
                                                    </div>
                                                    <div *ngIf="payment.AllowEditing">
                                                        <!-- "Change Frequency" disabled for payment with type "Scheduled" or if payment is disabled -->
                                                        <button
                                                            *ngIf="payment.PaymentType !== 'Scheduled' && payment.FrequencyTypeClassification.toLowerCase().indexOf('one off') === -1"
                                                            class="" [ngClass]="{
                                                        'glb_clickableIconButtonStyleNone glb_clickableIconButtonColorLight': payment.PaymentType !== 'Scheduled' && payment.IsEnabled, 
                                                        'glb_clickableIconButtonColorDisabled': payment.PaymentType === 'Scheduled' || !payment.IsEnabled
                                                    }" [disabled]="payment.PaymentType === 'Scheduled' || !payment.IsEnabled"
                                                            matTooltip="Change Frequency" (click)="ChangeFrequency_Click(payment)"
                                                            id="BTN_ChangeFrequency">
                                                            <fa-icon [icon]="['fal', 'wave-sine']" class="fa-md"></fa-icon>
                                                        </button>

                                                        <!-- "Defer Next Payment" only enabled for payment with type "Scheduled" -->
                                                        <button *ngIf="payment.PaymentType === 'Scheduled'" class="" [ngClass]="{
                                                        'glb_clickableIconButtonStyleNone glb_clickableIconButtonColorLight': payment.PaymentType === 'Scheduled', 
                                                        'glb_clickableIconButtonColorDisabled': payment.PaymentType !== 'Scheduled'
                                                    }" [disabled]="payment.PaymentType !== 'Scheduled'" matTooltip="Defer Next Payment"
                                                            (click)="DeferPayment_Click(payment)">
                                                            <fa-icon [icon]="['fal', 'calendar-pen']" class="fa-md"></fa-icon>
                                                        </button>

                                                        <!-- Disable button shown only for Scheduled Payment and when it's enabled -->
                                                        <button *ngIf="payment.PaymentType === 'Scheduled' && payment.IsEnabled"
                                                            class="glb_clickableIconButtonStyleNone glb_clickableIconButtonColorLight"
                                                            matTooltip="Disable Scheduled Payment" (click)="Payment_Disable(payment)">
                                                            <fa-icon [icon]="['fal', 'subtitles-slash']" class="fa-md"></fa-icon>
                                                        </button>

                                                        <!-- Enable button shown only when payment is disabled -->
                                                        <button *ngIf="!payment.IsEnabled"
                                                            class="glb_clickableIconButtonStyleNone glb_clickableIconButtonColorLight"
                                                            matTooltip="Enable Scheduled Payment" (click)="Payment_Enable(payment)">
                                                            <fa-icon [icon]="['fal', 'credit-card']" class="fa-md"></fa-icon>
                                                        </button>

                                                        <button *ngIf="payment.PaymentType !== 'Scheduled' || AllowScheduledPaymentDelete"
                                                            class="glb_clickableIconButtonStyleNone glb_clickableIconButtonColorLight"
                                                            (click)="Payment_Delete(payment)" matTooltip="Delete" id="BTN_Delete">
                                                            <fa-icon [icon]="['fal', 'trash']" class="fa-md"></fa-icon>
                                                        </button>

                                                        <button
                                                            class="glb_clickableIconButtonStyle glb_clickableIconButtonColorLight btn-secondary align-self-right"
                                                            (click)="Payment_Cancel(payment)">
                                                            <fa-icon class="fa-fw" [icon]="['fal', 'ban']" matTooltip="Click to finish editing">
                                                            </fa-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Add a small divider between rows unless it's the last one -->
                                        <div class="glb_customFlexRow col-12" *ngIf="i < ScheduledPaymentDetails.length - 1">
                                            <div class="col-12">
                                                <div class="horizontalLine"></div>
                                            </div>
                                        </div>

                                        <!-- Show this if no scheduled payments are available -->
                                        <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="ScheduledPaymentDetails.length === 0">
                                            <div class="col-12 ">No scheduled payments are available.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Manage Inter Account Transfer tab content -->
                <div *ngIf="CurrentTab === 'interAccountTransfer'" class="glb_boxedPadding glb_formBGColor glb_whiteTextDarkBG glb_Font col-12">
                    <div class="glb_customFlexRow row-cols-1 justify-content-left col-12">

                        <!-- Container with white border for linked accounts content -->
                        <div class="col-12 glb_allBordersGreyRounded glb_boxedPadding">
                            <div class="glb_TitleMD glb_paddingBottomSM">Linked Accounts</div>

                            <!-- Linked accounts list -->
                            <div *ngFor="let account of LinkedAccountDetails; let i = index">
                                <!-- Account details -->
                                <div class="glb_customFlexRow col-12">
                                    <div class="col-12">
                                        <div class="glb_customFlexRow col-12 glb_paddingBottomXS">
                                            <div class="col-3 glb_LabelFontDark">{{account.AccountID_lbl}}:</div>
                                            <div class="col-9 glb_whiteTextDarkBG">
                                                {{account.AccountID}}
                                            </div>
                                        </div>
                                        <div class="glb_customFlexRow col-12 glb_paddingBottomXS">
                                            <div class="col-3 glb_LabelFontDark">Available Balance:</div>
                                            <div class="col-9 glb_whiteTextDarkBG">{{account.AvailableBalance_lbl}}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Add a small gap between accounts unless it's the last one -->
                                <div class="glb_emptyRowSM" *ngIf="i < LinkedAccountDetails.length - 1"></div>
                            </div>

                            <!-- Divider before button -->
                            <div class="glb_emptyRowSM"></div>

                            <!-- Process Transfer Button -->
                            <div class="glb_customFlexRow col-12 glb_PaddingVerticalSM" *ngIf="AllowInterAccountTransfer">
                                <div class="col-6 col-md-4 col-lg-3">
                                    <button id="BTN_ProcessTransfer" tabindex="21"
                                        class="glb_standardButton btn glb_BGColorSkin glb_whiteTextDarkBG col-12"
                                        (click)="PaymentManagementModify_Launch('ProcessInterAccountTransfer')">
                                        <span class="glb_Font glb_smallerText">Process Transfer</span>
                                    </button>
                                </div>
                            </div>
                            <div class="glb_customFlexRow col-12 glb_PaddingVerticalSM" *ngIf="!AllowInterAccountTransfer">
                                <div class="col-6 col-md-4 col-lg-3">
                                    <button id="BTN_ProcessTransfer" tabindex="21"
                                        class="glb_standardButton btn glb_BGColorSkin glb_whiteTextDarkBG col-12" disabled>
                                        <span class="glb_Font glb_smallerText">Process Transfer</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Manage Direct Credit / Salary Credit / BPAY tab content -->
                <div *ngIf="CurrentTab === 'salaryCredit'" class="glb_boxedPadding glb_formBGColor glb_whiteTextDarkBG glb_Font col-12">
                    <div class="glb_customFlexRow row-cols-1 justify-content-left col-12">

                        <!-- Single container with white border for all content -->
                        <div class="col-12 glb_allBordersGreyRounded glb_boxedPadding">

                            <!-- Direct Credit / Salary Credit Section -->
                            <div *ngIf="ShowDirectCreditSalaryCredit" class="glb_customFlexRow col-12">
                                <div class="col-12">
                                    <div class="glb_TitleMD glb_paddingBottomSM">Direct Credit / Salary Credit</div>

                                    <!-- Salary Credit Details -->
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="SalaryCreditDetails">
                                        <div class="col-3 glb_LabelFontDark">BSB Number:</div>
                                        <div class="col-9 glb_whiteTextDarkBG">{{SalaryCreditDetails.BSBNumber || 'Not provided'}}</div>
                                    </div>
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="SalaryCreditDetails">
                                        <div class="col-3 glb_LabelFontDark">Account Number:</div>
                                        <div class="col-9 glb_whiteTextDarkBG">{{SalaryCreditDetails.AccountNumber || 'Not provided'}}</div>
                                    </div>
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="SalaryCreditDetails">
                                        <div class="col-3 glb_LabelFontDark">Account Name:</div>
                                        <div class="col-9 glb_whiteTextDarkBG">{{SalaryCreditDetails.AccountName || 'Not provided'}}</div>
                                    </div>

                                    <!-- Show this if no salary credit details are available -->
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="!SalaryCreditDetails">
                                        <div class="col-12 glb_whiteTextDarkBG">No direct credit / salary credit details available.</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Divider -->
                            <div class="glb_emptyRowSM"></div>

                            <!-- BPAY Section -->
                            <div class="glb_customFlexRow col-12">
                                <div class="col-12">
                                    <div class="glb_TitleMD glb_paddingBottomSM">BPAY</div>

                                    <!-- BPAY Details -->
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="BPAYDetails">
                                        <div class="col-3 glb_LabelFontDark">Biller Code:</div>
                                        <div class="col-9 glb_whiteTextDarkBG">{{BPAYDetails.BillerCode || 'Not provided'}}</div>
                                    </div>
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="BPAYDetails">
                                        <div class="col-3 glb_LabelFontDark">CRN:</div>
                                        <div class="col-9 glb_whiteTextDarkBG">{{BPAYDetails.CRN || 'Not provided'}}</div>
                                    </div>
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="BPAYDetails">
                                        <div class="col-3 glb_LabelFontDark">Account Name:</div>
                                        <div class="col-9 glb_whiteTextDarkBG">{{BPAYDetails.AccountName || 'Not provided'}}</div>
                                    </div>

                                    <!-- Show this if no BPAY details are available -->
                                    <div class="glb_customFlexRow col-12 glb_paddingBottomXS" *ngIf="!BPAYDetails">
                                        <div class="col-12 glb_whiteTextDarkBG">No BPAY details available.</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Divider before buttons -->
                            <div class="glb_emptyRowSM"></div> <!-- Buttons section -->
                            <div class="glb_customFlexRow col-12 glb_PaddingVerticalSM">
                                <div class="col-12 glb_customFlexRow justify-content-start">

                                    <!-- Generate Letter Button -->
                                    <div class="col-6 col-md-4 col-lg-3 glb_paddingRightXS">
                                        <button id="BTN_GenerateEmail" tabindex="19" class="glb_standardButton btn glb_BGColorSkin text-white col-12"
                                            (click)="BPAYLetter_Generate()">
                                            <span class="glb_Font glb_smallerText">Generate Letter</span>
                                        </button>
                                    </div>

                                    <!-- Close Button -->
                                    <div class="col-6 col-md-4 col-lg-3 glb_paddingLeftXS">
                                        <button id="BTN_CloseDialog" tabindex="20" class="glb_standardButton btn glb_BGColorSkin text-white col-12"
                                            (click)="globalFunctions.FeatureModal_Close(ModalIdentifier)">
                                            <span class="glb_Font glb_smallerText">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Pop up dialog for adding new user-->
<ng-template #ViewFeeDetailsTemplate>
    <div id="PG_ViewFeeDetails" class="glb_formBGColor glb_boxedPadding glb_Font glb_Font">

        <!-- Close modal button. put this here on its own row, so that it stays put and won't bootstrap down to another row in smaller screen sizes -->
        <div class="glb_customFlexRow justify-content-end">
            <div class="justify-content-start glb_boxedPaddingNarrow align-self-bottom glb_PaddingVerticalZeroOffset">
                <button id="BTN_CloseFeeDetails" tabindex="3"
                    class="btn glb_clickableIconButtonStyleNone glb_clickableIconButtonColorDark glb_skinLightOutline" type="button"
                    (click)="globalFunctions.FeatureModal_Close(FeeModalIdentifier)">
                    <fa-icon [icon]="['fal', 'times']" class="fa-md glb_modalClose"></fa-icon>
                </button>
            </div>
        </div>
        <div class="glb_Font header-padding glb_customFlexRow text-white">
            <div class="glb_customFlexRow col-12">
                <div class="glb_customFlexRow col-8 glb_paddingZeroOffset">
                    <div class="col-8 glb_paddingZeroOffset">
                        <div class="glb_TitleLG glb_TitleLGMobile text-start glb_breakLongWords glb_paddingZeroOffset glb_paddingBottomSM">
                            Scheduled Payment Fee Details
                        </div>
                    </div>
                </div>
            </div>

            <!-- Display Fee Deatils-->
            <div class="glb_boxedPaddingNarrow col-12">
                <div class="glb_allBordersSkin glb_Font col-12 glb_customFlexRow glb_PaddingHorizontalMD">
                    <div class="glb_customFlexRow col-12 glb_paddingZeroOffset glb_paddingBottomSM">
                        <div class="glb_thinBottomWhiteBorder glb_customFlexRow col-12 glb_paddingZeroOffset row-cols-4">
                            <div class="glb_customFlexRow align-items-center">
                                <div>Task Type</div>
                            </div>
                            <div class="glb_customFlexRow align-items-center">
                                <div>Process Amount</div>
                            </div>
                            <div class="glb_customFlexRow align-items-center">
                                <div>Transaction Type</div>
                            </div>
                            <div class="glb_customFlexRow align-items-center">
                                <div>Status</div>
                            </div>
                        </div>
                    </div>
                    <div *ngFor="let fee of SelectedPayment.ScheduledPaymentFeeList; let i = index"
                        class="col-12 glb_customFlexRow glb_paddingZeroOffset">
                        <div class="glb_customFlexRow glb_paddingZeroOffset glb_paddingBottomSM col-12 row-cols-4">

                            <div class="glb_customFlexRow align-items-center">
                                <div class="col-11">{{fee.TaskType}}</div>
                            </div>
                            <div class="glb_customFlexRow align-items-center">
                                <div>{{fee.ProcessAmount_lbl}}</div>
                            </div>
                            <div class="glb_customFlexRow align-items-center">
                                <div>{{fee.TransactionType}}</div>
                            </div>
                            <div class="glb_customFlexRow align-items-center">
                                <div>{{fee.FeeTransferStatus}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="glb_customFlexRow glb_thinTopWhiteBorder col-12 glb_PaddingVerticalSM row-cols-4 glb_TitleMD">
                        <div class="glb_customFlexRow align-items-center">
                            <div>Total</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div>{{TotalConsolidatedFeeAmount_lbl}}</div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div></div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div></div>
                        </div>
                        <div class="glb_customFlexRow align-items-center">
                            <div></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>